export default __webpack_public_path__ + "static/media/bernay5.df2ff2a8.jpg";